import {
  BadgeAlertMessage,
  TBadgeAlertSize,
  TBadgeAlertVariant,
} from '@noissue-ui-kit/badgeAlertMessage'
import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { useDesignerChatbotData } from './UnifiedEditorProvider'
import isEmpty from 'lodash/isEmpty'
import { IImage } from '@utils/contentful/contentfulImage'
import {
  useFilesWithState,
  useHasSvgConvertableFiles,
} from './designUpload/components/UploadDropzone/UploadDropzone.provider'

export interface IDesignerChatbot {
  image: IImage
  text: string
  size?: TBadgeAlertSize
  mode?: TBadgeAlertVariant
}

export function DesignerChatbot() {
  const { filesWithState } = useFilesWithState()
  const hasSvgConvertableFile = useHasSvgConvertableFiles()

  const { designerChatbot } = useDesignerChatbotData({
    editorHasUploadedFiles: Boolean(filesWithState?.length),
    editorHasSvgConvertableFile: hasSvgConvertableFile,
  })

  return (
    !isEmpty(designerChatbot) && (
      <BadgeAlertMessage
        badge={{
          alt: designerChatbot?.image?.imageTitle,
          url: designerChatbot?.image?.imageUrl,
        }}
        size={designerChatbot.size || 'm'}
        borderType="square-round"
        variant={designerChatbot.mode || 'attention'}
        className="py-2.5 pl-6 mb-10"
      >
        <ContentfulMarkdown overrideClass="text-xl text-acai font-mori">
          {designerChatbot?.text}
        </ContentfulMarkdown>
      </BadgeAlertMessage>
    )
  )
}
